// extracted by mini-css-extract-plugin
export default {"container":"style_container__V33pd","address":"style_address__ZRfUq","rightHandSide":"style_rightHandSide__s1az7","price":"style_price__He2Xo"};